import { LegalContentCms } from 'features/LegalContentCms';
import {
  redirectFromHelp,
  handleLegalContentCmsEnter,
  redirectFromHelpTerms,
} from 'features/LegalContentCms/LegalContentCms.saga';

export default [
  {
    path: '/help/:slug/terms',
    component: LegalContentCms,
    pathSagas: [handleLegalContentCmsEnter],
    isPublic: true,
  },
  {
    path: '/help/terms',
    component: null,
    pathSagas: [redirectFromHelpTerms],
    isPublic: true,
  },
  {
    path: '/help',
    component: null,
    pathSagas: [redirectFromHelp],
  },
];
